/**
 *-------------------------------------------
 * apis in common, routes.jsx, login page, register page, verify page...
 *-------------------------------------------
 */

import { postData } from '../../request'

export function logout(body) {
    return postData('/api/logout/', body)
}

// eslint-disable-next-line
export const eMailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const phoneNumberReg = /^(\+81)?0?[5789]0-?[0-9]{4}-?[0-9]{4}$/
